module.exports = "/lucky-balls/img/bonus_yellow/footer.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/bonus_yellow/footer.png
// module id = 961
// module chunks = 0